import React, {useCallback, useEffect, useState} from 'react';
import './App.css';
import {Route, Routes, useLocation} from "react-router-dom";
import {AnimatePresence} from "framer-motion";
import {Home} from "./pages/Home";
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import {LinkContainer} from 'react-router-bootstrap'
import {Category, CategoryInterface} from './pages/Category';
import {Icon} from "./Icon";
import {Sub} from "./pages/Sub";
import {Lesson} from './pages/Lesson';
import {applyReplacements} from "./components/Replacements";
import Alert from "react-bootstrap/Alert";

export const API = process.env.REACT_APP_API;

export interface apiCallbacks {
    requireAuthCallback: (response: Response) => Promise<any>,
    authCheckCatchCallback: (error: Error) => void
}

function App() {
    const [options, setOptions] = useState<CategoryInterface[]>([]);
    const location = useLocation();
    const authCheckCatchCallback = useCallback((error: Error) => {
        if (error.message !== 'Not authorized') return;
        document.location.href = `${API}/login`;
    }, [])
    const requireAuthCallback = useCallback((response: Response) => {
        if (response.status === 403) {
            throw new Error('Not authorized');
        }
        return response.json()
    }, [])

    useEffect(() => {
        fetch(`${API}/categories/`, {credentials: "include"})
            .then(requireAuthCallback)
            .then((data) => setOptions(data))
            .catch(authCheckCatchCallback);
    }, [authCheckCatchCallback, requireAuthCallback]);

    const getKey = () => {
        return location.pathname
    }

    return (
        <>
            <Navbar expand="lg">
                <Container>
                    <LinkContainer to="/">
                        <Navbar.Brand>3Vids 🎬</Navbar.Brand>
                    </LinkContainer>
                    <Navbar.Collapse>
                        <Nav className="me-auto">
                            <NavDropdown title="Уроци">
                                {options.length === 0 &&
                                    <NavDropdown.Item disabled={true}>секунда...</NavDropdown.Item>}
                                {options.map((option) => (
                                    <LinkContainer to={`/category/${option.tag}/`}>
                                        <NavDropdown.Item className="d-flex">
                                            <Icon iconName={option.icon} className="me-2 my-auto"></Icon>
                                            <p className="my-0">{option.title}</p>
                                            <div className="dropdown-menu dropdown-submenu flex-column">
                                                {option.subs.map((sub) => (
                                                    <LinkContainer to={`/category/${option.tag}/${sub}`}>
                                                        <NavDropdown.Item className="d-flex">
                                                            <p className="my-0">{applyReplacements(sub)}</p>
                                                        </NavDropdown.Item>
                                                    </LinkContainer>
                                                ))}
                                            </div>
                                        </NavDropdown.Item>
                                    </LinkContainer>
                                ))}
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Alert role="alert" variant="info" className="mx-4 text-center">При проблем, моля свържете се с администратора.</Alert>
            <AnimatePresence mode="wait">
                {/*<Container className="w-100 h-100">*/}
                <Routes key={getKey()} location={location}>
                    <Route path="*" element={<Home allOptions={options}/>}/>
                    <Route path="/category/:category" element={<Category allOptions={options}/>}/>
                    <Route path="/category/:category/:sub"
                           element={<Sub
                               allOptions={options}
                               skip={false}
                               requireAuthCallback={requireAuthCallback}
                               authCheckCatchCallback={authCheckCatchCallback}/>
                           }/>
                    <Route path="/category/:category/:sub/change"
                           element={<Sub
                               allOptions={options}
                               skip={true}
                               requireAuthCallback={requireAuthCallback}
                               authCheckCatchCallback={authCheckCatchCallback}/>
                           }
                    />
                    <Route path="/category/:category/:sub/:urok_id/:lesson_id"
                           element={<Lesson
                               requireAuthCallback={requireAuthCallback}
                               authCheckCatchCallback={authCheckCatchCallback}/>
                           }
                    />
                </Routes>
                {/*</Container>*/}

            </AnimatePresence>
        </>
    );
}

export default App;
